<template>

    <div id="app">
      <nav>
        

        <a class="logo" href="#/">
          <img :src="assets.img.logo" />
        </a>

        <creek-audio-sidebar></creek-audio-sidebar>

        <img class="cartoon" :src="assets.cartoons.home" />

      </nav>

      <main>
      
        <div class="nav-top">
          <a href="#/">Home</a>
          <a href="#/shows" class="active">Shows & Archives</a>
          <a href="#/info">Info</a>
          <a href="#/donate">Donate</a>
        </div>

        <router-view/>
      
      </main>

      <aside>

        <div class="twitter-container">
          <!-- <h2>Twitter</h2> -->
          <a class="twitter-timeline" data-width="320" data-height="400" data-theme="light" data-link-color="#1da1f2" href="https://twitter.com/KWMRradio?ref_src=twsrc%5Etfw">Tweets by KWMRradio</a>
        </div>

        <h2>Weather</h2>

      </aside>

    </div>

</template>

<script>

  import Vue from 'vue'

  import Images_Logo from "./assets/img/logo-1.png";
  import Images_Background from "./assets/img/background-1.jpg";

  // Jaime Icons
  import Cartoon_Icon_Home from "./assets/img/jaime-icons/Icon_Home.jpg";

  export default {
    name: "App",
    data () {
      return {

        assets: {
          img: {
            logo: Images_Logo,
            background: Images_Background
          },
          cartoons: {
            home: Cartoon_Icon_Home
          }
        },
        audio: this.Creek.audio

      }
    }
  }
</script>
